import { render, staticRenderFns } from "./SignupPageEdit.vue?vue&type=template&id=4467e520"
import script from "./SignupPageEdit.vue?vue&type=script&lang=js"
export * from "./SignupPageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports